<script setup lang="ts">
import { useGenerateIds } from '../../composables';

//simulate old {% box %} macro, but only handle either both classes (horizontal) or none (vertical, inline)
const props = defineProps<{
    id?: string;
    name?: string;
    label?: string | boolean;
    labelClass?: string;
    controlClass?: string;
    plain?: boolean;
}>();

const generateIds = useGenerateIds();

const controlId = props.id || generateIds();
const controlName = props.name || controlId;

</script>
<template>
    <div class="mobile-label-box">
        <label :for="controlId">
            <slot name="label">
                <span class="mobile-label-upper">{{ props.label }}</span>
            </slot>
        </label>
        <div class="mobile-control">
            <slot :nameprops="{id: controlId, name: controlName}" />
        </div>
    </div>
</template>
<style>
.mobile-label-upper {
    text-transform: uppercase;
}
</style>
<style scoped>
.mobile-label-box {
    margin-bottom: 20px;
}
</style>
